<div class="loading-overlay-wrapper" *ngIf="isLoading">
  <div class="loading-overlay-content">
    <mat-spinner [diameter]="spinnerDiameter"></mat-spinner>
    <h3>{{title}}</h3>
    <p>{{message}}</p>
  </div>
</div>

